import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { setCurrentWellInLocalStorage } from 'services/localStorer';
import { WellFullDetailsWithUniqueKeyDTO } from 'types/well';
import { InnerWellboreWithWellInfo } from 'types/wellbore';

export type WellsState = Readonly<{
  currentWell?: WellFullDetailsWithUniqueKeyDTO;
  currentWellbore?: InnerWellboreWithWellInfo;
  currentTimezone: number;
  authorizedWells: WellFullDetailsWithUniqueKeyDTO[];
  authorizedWellbores: InnerWellboreWithWellInfo[];
}>;

export const initialState: WellsState = {
  authorizedWells: [],
  authorizedWellbores: [],
  currentWell: undefined,
  currentWellbore: undefined,
  currentTimezone: 0,
};

const wellsSlice = createSlice({
  name: 'Wells',
  initialState,
  reducers: {
    updateAuthorizedWellsAndWellbores: (
      state,
      action: PayloadAction<WellFullDetailsWithUniqueKeyDTO[]>,
    ) => {
      state.authorizedWells = action.payload;
      const authorizedWellbores: InnerWellboreWithWellInfo[] = [];
      action.payload.forEach(well => {
        well?.wellbores?.forEach(wellbore => {
          authorizedWellbores.push({
            ...wellbore,
            well: { ...well, wellbores: undefined },
          });
        });
      });
      state.authorizedWellbores = authorizedWellbores;
    },
    updateCurrentWellAndWellbore: (
      state,
      {
        payload: { well, wellbore },
      }: PayloadAction<{
        wellbore?: InnerWellboreWithWellInfo;
        well?: WellFullDetailsWithUniqueKeyDTO;
      }>,
    ) => {
      state.currentWellbore = wellbore;
      state.currentWell = well;
      state.currentTimezone = well?.timezoneOffset ?? 0;
      setCurrentWellInLocalStorage({ wellId: well?.wellId, tuwi: well?.tuwi });
    },
    updateCurrentTimezone: (state, { payload }: PayloadAction<number>) => {
      state.currentTimezone = payload;
    },
  },
});

export const {
  updateAuthorizedWellsAndWellbores,
  updateCurrentWellAndWellbore,
  updateCurrentTimezone,
} = wellsSlice.actions;

export default wellsSlice.reducer;
